import { render, staticRenderFns } from "./weekSelect.vue?vue&type=template&id=3b94d016&"
import script from "./weekSelect.vue?vue&type=script&lang=js&"
export * from "./weekSelect.vue?vue&type=script&lang=js&"
import style0 from "./weekSelect.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports